<template>
    <component :is="tag"
               class="editable tw-group tw-relative"
               :class="classes"
               :contenteditable="editable && !untouchable"
               @keydown.prevent.enter="$event.target.blur()"
               @keyup.prevent="onUpdate($event)"
               @focus="focus = true"
               @blur="focus = false"
    >
    </component>
</template>

<script>
import {throttle} from "lodash-es";

export default {
    name: "SurveyPageEditable",
    props: {
        target: {
            required: false
        },
        editable: {
            type: Boolean,
            default: false
        },
        tag: {
            type: String,
            default: 'div'
        },
        attr: {
            type: String,
            required: false,
        },
        default: {
            type: String,
            required: false
        },
        untouchable: {
            type: Boolean,
            default: false
        }
        
    },
    data() {
        return {
            focus: false,
        }
    },
    watch: {
        'target.id'() {
            this.showEditableValue();
        },
        target() {
            if (!this.focus) this.showEditableValue();
        },
        editable() {
            this.showEditableValue();
        },
    },
    computed: {
        value() {
            if (this.attr) return this.target[this.attr];
            else return this.target;
        },
        classes() {
            let _classes = {'fillable': this.editable}
            if (this.attr) _classes[this.attr] = true;
            if (this.untouchable) _classes['untouchable'] = true;
            if (!this.editable && !this.untouchable && !this.default && !this.value) _classes['hidden'] = true;
            return _classes;
        }
    },
    methods: {
        showEditableValue() {
            if (this.default && !this.value) this.$el.innerText = this.default;
            else this.$el.innerText = this.value;
        },
        triggerUpdate(event) {
            let text = event.target.innerText;
            
            if (this.attr) {
                const payload = { id: this.target.id };
                payload[this.attr] = text;
                this.$emit('changed', payload);
            } else {
                this.$emit('changed', text);
            }
        }
    },
    mounted() {
        this.showEditableValue();
        this.onUpdate = throttle(event => {
            this.triggerUpdate(event);
        }, 1000);
    },
}
</script>

<style scoped>

</style>